import React from "react";
import { LegalLayout, Section, Field, InfoNote } from "../components/legal/LegalLayout";
import { legalConfig } from "../data/legalConfig";

export default function MentionsLegales() {
  const a = legalConfig.legalAddress;
  return (
    <LegalLayout
      title="Mentions légales"
      description="Mentions légales de Louis-Melchior Danse — Identité de l'éditeur, hébergeur, propriété intellectuelle et responsabilité."
      testId="page-mentions-legales"
      breadcrumbPath="/mentions-legales"
    >
      <p className="text-base mb-8">
        Conformément à la loi n°2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique, les utilisateurs du site {legalConfig.domain} sont informés de l'identité de l'éditeur et de l'hébergeur du site.
      </p>

      <Section title="Éditeur du site" testId="ml-editeur">
        <Field label="Nom" value={legalConfig.publisherFullName} />
        <Field label="Nom commercial" value={legalConfig.brandName} />
        <Field label="Forme juridique" value={legalConfig.legalForm} />
        <Field label="Adresse" value={`${a.line1}, ${a.postalCode} ${a.city}, ${a.country}`} />
        <Field label="SIREN" value={legalConfig.siren} />
        <Field label="SIRET" value={legalConfig.siret} />
        <Field label="Code APE" value={`${legalConfig.apeCode} — ${legalConfig.apeLabel}`} />
        <Field label="Immatriculation" value={`${legalConfig.registrationAuthority}, ${legalConfig.registrationDate}`} />
        <Field label="Activité" value={legalConfig.activityNature} />
        <Field
          label="Téléphone"
          value={
            <a href={`tel:${legalConfig.contactPhoneE164}`} className="text-[#C9A869] hover:text-[#DCC28E] underline underline-offset-4">
              {legalConfig.contactPhone}
            </a>
          }
        />
        <Field
          label="Email"
          value={
            <a href={`mailto:${legalConfig.contactEmail}`} className="text-[#C9A869] hover:text-[#DCC28E] underline underline-offset-4">
              {legalConfig.contactEmail}
            </a>
          }
        />
        <Field label="TVA" value={legalConfig.vatMention} />
      </Section>

      <Section title="Directeur de la publication" testId="ml-directeur">
        <p>{legalConfig.publicationDirector}, en sa qualité d'entrepreneur individuel.</p>
      </Section>

      <Section title="Hébergement" testId="ml-hebergement">
        <Field label="Hébergeur" value={legalConfig.hosting.name} />
        <Field label="Site web" value={<a href={legalConfig.hosting.website} target="_blank" rel="noopener noreferrer" className="text-[#C9A869] hover:text-[#DCC28E] underline underline-offset-4">{legalConfig.hosting.website}</a>} />
        <Field label="Coordonnées légales" value={legalConfig.hosting.address} />
      </Section>

      <Section title="Propriété intellectuelle" testId="ml-pi">
        <p>
          L'ensemble des contenus présents sur ce site (textes, photographies, vidéos, logo, identité graphique, éléments d'interface, mise en page) est la propriété exclusive de {legalConfig.brandName}, ou est utilisé avec l'autorisation de leurs ayants droit. Toute reproduction, représentation, modification ou diffusion, totale ou partielle, par quelque procédé que ce soit, sans autorisation écrite préalable est interdite et constitue une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle.
        </p>
        <p>
          Les marques, logos et noms de domaine apparaissant sur ce site sont protégés. Aucune licence ou droit d'utilisation ne peut en être déduit de leur affichage.
        </p>
      </Section>

      <Section title="Responsabilité" testId="ml-responsabilite">
        <p>
          Les informations présentes sur le site sont fournies à titre indicatif. {legalConfig.brandName} s'efforce d'en assurer l'exactitude et la mise à jour, mais ne saurait être tenu responsable d'erreurs, d'omissions ou d'une indisponibilité ponctuelle du site. Les modalités précises (date, lieu, durée, tarif) de chaque cours sont confirmées par écrit ou par téléphone avant toute réservation.
        </p>
        <p>
          Les liens externes vers des sites tiers sont fournis pour la commodité de l'utilisateur. {legalConfig.brandName} n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu, leur disponibilité ou leur politique de confidentialité.
        </p>
      </Section>

      <Section title="Médiation de la consommation" testId="ml-mediation">
        <p>
          Conformément à l'article L.616-1 du Code de la consommation, le consommateur a le droit de recourir gratuitement à un médiateur de la consommation en vue de la résolution amiable d'un litige.
        </p>
        {legalConfig.consumerMediator.designated ? (
          <>
            <Field label="Médiateur désigné" value={legalConfig.consumerMediator.name} />
            <Field label="Adresse" value={legalConfig.consumerMediator.address} />
            <Field label="Site internet" value={legalConfig.consumerMediator.website} />
          </>
        ) : (
          <InfoNote variant="warning">
            <strong>Information transparente :</strong> {legalConfig.brandName} procède actuellement à l'adhésion auprès d'un médiateur de la consommation agréé. Les coordonnées exactes du médiateur compétent seront publiées ici dès la finalisation de cette démarche. En attendant, pour toute réclamation, vous pouvez écrire directement à {legalConfig.contactEmail}.
          </InfoNote>
        )}
      </Section>

      <Section title="Droit applicable" testId="ml-droit">
        <p>
          Le présent site et les présentes mentions légales sont soumis au droit français. En cas de litige, et après tentative de résolution amiable, les tribunaux français seront seuls compétents.
        </p>
      </Section>
    </LegalLayout>
  );
}
